import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import credit from "../../../assets/crédito.png";
import debit from "../../../assets/débito.png";
import opp from "../../../assets/openpay_contraste.png";
import UseOpenpay from "../../UI/formcard/hooks/openpay";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import AlertTitle from "@mui/material/AlertTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Auth, API, graphqlOperation } from "aws-amplify";
import { getidCard } from "../../../graphql/myQueries";
import { useHistory } from "react-router-dom";
import { usePaymentInputs } from "react-payment-inputs";
import "../formcard/style/style.css";

const useStyles = makeStyles((theme) => ({
  profileContainer: {
    marginTop: "5vh",
    minHeight: "90vh",
    padding: "30px 15px",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: 20,
    width: "50%",
    marginLeft: "25%",
    backgroundColor: "#fff",
    borderRadius: "15px",
  },
  info: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
    flexDirection: "column",
    gap: 2,
    backgroundColor: "yellow",
  },
  butonscontainer: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  inputdate: {
    marginBottom: theme.spacing(3),
    flexDirection: "row",
    display: "flex",
  },
  inputmonth: {
    width: "50%",
  },
  inputYear: {
    marginLeft: "20%",
    width: "30%",
  },
  credit: {
    width: "40%",
  },
  debit: {
    width: "60%",
  },
  inputopp: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  cntbtn: {
    marginTop: "2%",
    width: "50%",
    backgroundColor: "#EA5B13",
  },
  textinfo: {
    fontSize: 13,
  },
  texttitle: {
    fontSize: 16,
    fontWeight: "500",
  },
  cntbtnloading: {
    marginTop: "2%",
    width: "50%",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  alert: {
    position: "relative",
    marginLeft: "60%",
    marginTop: "-5%",
  },
}));

const loadingcircle = styled(CircularProgress)(({ theme }) => ({
  color: "#EA5B13",
  backgroundColor: "#EA5B13",
}));

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#004990",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#EA5B13",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#004990",
    },
    "&:hover fieldset": {
      borderColor: "#004990",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#EA5B13",
    },
  },
  label: { color: "#004990" },
});

const ColorButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: "#EA5B13",
  "&:hover": {
    backgroundColor: "#004990",
  },
}));

function makeid(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * 
charactersLength));
 }
 return result;
}

const cardinfo = {
  card_number: "",
  holder_name: "",
  expiration_year: "",
  expiration_month: "",
  cvv2: "",
  device_session_id: makeid(15),
};

const formatNumber = (value) => {
  if (!value) return value;

  return value.replace(/[^0-9]/g, "");
};



export default function RegisterCard() {
  const { getCardNumberProps } = usePaymentInputs();
  let redirect = useHistory();
  const classes = useStyles();
  const [openalert, setopenalert] = useState(false);
  const [loading, setloading] = useState(false);
  const { createCardtoClient, createClient, updatebd } = UseOpenpay();
  const [dataCard, setdata] = useState(cardinfo);
  const [error, seterror] = useState(false);
  const [idoppbd, setidopp] = useState("");
  const [email, setemail] = useState("");
  const [idSHop, setIdshop] = useState("");
  const [_idopp, _setidopp] = useState("");
  const [availableCard, setavailableCard] = useState(false);
  const [clientfunction, setclientfunction] = useState("");

  const sendinfoCard = {
    card_number: formatNumber(dataCard.card_number),
    holder_name: dataCard.holder_name,
    expiration_year: dataCard.expiration_year,
    expiration_month: dataCard.expiration_month,
    cvv2: dataCard.cvv2,
    device_session_id: dataCard.device_session_id,
  }

  function setInput(key, value) {
    setdata({ ...dataCard, [key]: value });
  }

  useEffect(() => {
    if (openalert) {
      setTimeout(() => {
        setopenalert(false);
      }, 2000);
    } else {
      console.log("no hay alerta");
    }
  }, [openalert]);

  useEffect(() => {
    getUserLoggedIn();
  }, []);

  async function getUserLoggedIn() {
    try {
      const response = await Auth.currentAuthenticatedUser();
      setemail(
        response.attributes.email !== undefined ? response.attributes.email : ""
      );
      setIdshop(
        response.attributes.sub !== undefined ? response.attributes.sub : ""
      );
      const responseOpenpay = await API.graphql(
        graphqlOperation(getidCard, { id: response.attributes.sub })
      );
      var idopenpay = responseOpenpay.data.getAccount.openPay_id;

      _setidopp(JSON.parse(idopenpay));
      setidopp(idopenpay != null && idopenpay != "" ? idopenpay : "");
    } catch (err) {
      console.log("Hubo un error al recuperar al usuario" /* err */);
    }
  }

  function CreateCard(customerid) {
    createCardtoClient(customerid, sendinfoCard, function (error, card) {
      if (error) {
        //console.log("Error al crear la tarjeta", error);
        setloading(false);
        seterror(true);
        setopenalert(true);
        setclientfunction(customerid);
        updatebd(
          customerid,
          "card",
          "",
          idSHop,
          _idopp != null ? _idopp.idclabe : ""
        ); //*Actualizo la BD para que no se vuelva a crear el cliente en opp
      } else {
        setclientfunction("");
        updatebd(
          customerid,
          "card",
          card.id,
          idSHop,
          _idopp != null ? _idopp.idclabe : ""
        );
        setloading(false);
        setopenalert(true);
        redirect.push("/elegir");
      }
    });
  }

  function CreateClient() {
    setloading(true);
    getUserLoggedIn();
    if (idoppbd != "" || clientfunction != "") {
      //*Asignación del json de la bd para buscar la propiedad que ocupemos
      console.log("idopp", _idopp);
      var idopp = _idopp != null ? _idopp.idcard : "";
    
      if (idopp != "" && idopp != undefined) {
        //*Ya tIene tarjeta guarada en bd y ya no puede registrar nada
        setavailableCard(true);
        setloading(false);
        seterror(true);
        setopenalert(true);
      } else {
        //*Si el estado de cliente ya va lleno es por que ya lo creo y solo se creara una tarjeta
        CreateCard(clientfunction != "" ? clientfunction : _idopp.openPay_id);
      }
    } else {
      createClient(
        {
          name: sendinfoCard.holder_name,
          email: email,
          requires_account: false,
        },
        function (error, customer) {
          if (error) {
            //console.log("Error al crear el cliente", error);
            setloading(false);
            setopenalert(true);
            seterror(true); //!activo el error para mostrar que no se registro el cliente
          } else {
            //console.log("Cliente creado", customer);
            CreateCard(customer.id); //Se crea la tarejata a ese cliente
          }
        }
      );
    }
  }

  return (
    <>
      <div className={classes.profileContainer}>
        <div className={classes.butonscontainer}>
          <div className={classes.input}>
            <CssTextField
              id="outlined-basic"
              label="Nombre del titular"
              variant="outlined"
              size="small"
              value={dataCard.holder_name}
              onChange={(e) => setInput("holder_name", e.target.value)}
              fullWidth
              type="text"
              maxLength={16}
            />
          </div>

          <div className={classes.input}>
            <input
              className="inputnumber"
              maxWidth="150rem"
              {...getCardNumberProps({
                onChange: (e) => setInput("card_number", e.target.value),
              })}
              value={dataCard.card_number}
              placeholder="Número de tarjeta"
            />
            {/* <CssTextField
              id="outlined-basic"
              label="Número de tarjeta"
              variant="outlined"
              size="small"
              fullWidth
              type="text"
              value={dataCard.card_number}
              onChange={(e) => setInput("card_number", e.target.value)}
            /> */}
          </div>
          <div className={classes.inputdate}>
            <div className={classes.inputmonth}>
              <CssTextField
                fullWidth
                size="small"
                id="outlined-basic"
                label="MM"
                variant="outlined"
                type="number"
                value={dataCard.expiration_month}
                onChange={(e) => setInput("expiration_month", e.target.value)}
              />
            </div>
            <div className={classes.inputYear}>
              <CssTextField
                fullWidth
                size="small"
                id="outlined-basic"
                label="AA"
                variant="outlined"
                type="number"
                value={dataCard.expiration_year}
                onChange={(e) => setInput("expiration_year", e.target.value)}
              />
            </div>
          </div>

          <div className={classes.input}>
            <CssTextField
              id="outlined-basic"
              label="CVV"
              variant="outlined"
              size="small"
              sx={{ color: "black" }}
              type="number"
              value={dataCard.cvv2}
              onChange={(e) => setInput("cvv2", e.target.value)}
            />
          </div>
          <div className={classes.inputdate}>
            <div className={classes.credit}>
              <p className={classes.texttitle}>Tarjetas de crédito</p>
              <img src={credit} alt="credit" width="80%" />
            </div>
            <div className={classes.debit}>
              <p className={classes.texttitle}>Tarjetas de débito</p>
              <img src={debit} alt="debit" width="100%" />
            </div>
          </div>
          <div className={classes.inputopp}>
            <div className={classes.credit}>
              <p className={classes.texttitle}>Transacciones realizadas via:</p>
              <img src={opp} alt="opp" width="80%" />
              <p className={classes.textinfo}>
                Tus transacciones se realizan de forma segura con encriptación
                de 256 bits
              </p>
            </div>
            {loading ? (
              <div className={classes.cntbtnloading}>
                <CircularProgress className={loadingcircle} />
              </div>
            ) : (
              <div className={classes.cntbtn}>
                <ColorButton
                  variant="contained"
                  fullWidth
                  onClick={() => CreateClient()}
                >
                  Guardar
                </ColorButton>
              </div>
            )}
          </div>
        </div>
      </div>
      {openalert ? (
        <div className={classes.alert}>
          <Stack
            sx={{ width: "100%", marginTop: "-2%", marginBottom: "1%" }}
            spacing={4}
          >
            {error ? (
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                Instrucción incorrecta —{" "}
                {availableCard ? (
                  <strong>Ya cuentas con una tarjeta registrada!</strong>
                ) : (
                  <strong>Valida tus datos!</strong>
                )}
              </Alert>
            ) : (
              <Alert severity="success">
                <AlertTitle>Correcta</AlertTitle>
                Instrucción correcta —{" "}
                <strong>Se ha guardado correctamente!</strong>
              </Alert>
            )}
          </Stack>
        </div>
      ) : null}
    </>
  );
}
